import { Record } from 'immutable';

const {
    REHYDRATION_COMPLETED,
    SET_VERSION,
    SET_BREADCRUMB,

    CONTACT_REQUEST,
    CONTACT_SUCCESS,
    CONTACT_FAILURE,

    BOOK_SESSION_REQUEST,
    BOOK_SESSION_SUCCESS,
    BOOK_SESSION_FAILURE,

    GET_STATS_REQUEST,
    GET_STATS_SUCCESS,
    GET_STATS_FAILURE,

    GET_GENERAL_PAGE_REQUEST,
    GET_GENERAL_PAGE_SUCCESS,
    GET_GENERAL_PAGE_FAILURE,

    GET_APP_BRAND_REQUEST,
    GET_APP_BRAND_SUCCESS,
    GET_APP_BRAND_FAILURE
} = require('./globalActions').constants;

const InitialState = Record({
    isFetching: false,
    error: null,
    version: null,
    breadcrumb: [],
    rehydrationCompleted: false,
    stats: {},
    pages: {},
    brand: {}
});

const initialState = new InitialState();
/**
 * ## globalReducer function
 * @param {Object} state - initialState
 * @param {Object} action - type and payload
 */
export default function globalReducer(state = initialState, { payload, type }) {
    if (!(state instanceof InitialState)) return initialState.merge(state);

    switch (type) {
    case SET_VERSION:
        return state.set('version', payload);

    case SET_BREADCRUMB:
        return state.set('breadcrumb', payload);

    case REHYDRATION_COMPLETED:
        return state.set('rehydrationCompleted', payload);

    case CONTACT_REQUEST:
    case BOOK_SESSION_REQUEST:
    case GET_STATS_REQUEST:
    case GET_GENERAL_PAGE_REQUEST:
    case GET_APP_BRAND_REQUEST:
        return state.set('isFetching', true)
                .set('error', null);

    case CONTACT_SUCCESS:
    case BOOK_SESSION_SUCCESS:
        return state.set('isFetching', false);

    case GET_STATS_SUCCESS:
        return state.set('isFetching', false)
            .set('stats', payload.data);

    case GET_GENERAL_PAGE_SUCCESS: {
        const pages = state.pages;
        pages[payload.name] = payload.data;
        return state.set('isFetching', false)
            .set('pages', pages);
    }

    case GET_APP_BRAND_SUCCESS:
        return state.set('isFetching', false)
            .set('brand', payload.data);

    case CONTACT_FAILURE:
    case BOOK_SESSION_FAILURE:
    case GET_STATS_FAILURE:
    case GET_GENERAL_PAGE_FAILURE:
    case GET_APP_BRAND_FAILURE:
        return state.set('isFetching', false)
                .set('error', payload);

    default:
        return state;

    }
}



/** WEBPACK FOOTER **
 ** ./src/core/global/globalReducer.js
 **/